import { render, staticRenderFns } from "./adminOwnerList.vue?vue&type=template&id=da85d15a&scoped=true"
import script from "./adminOwnerList.vue?vue&type=script&lang=js"
export * from "./adminOwnerList.vue?vue&type=script&lang=js"
import style0 from "./adminOwnerList.vue?vue&type=style&index=0&id=da85d15a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da85d15a",
  null
  
)

export default component.exports